module.exports = __webpack_public_path__ + "img/ocb_qr.0f8c847f.png";